/*
 * 加入購物車（Dawn product-form）
 *
 * <product-form data-im-dupe-check data-product-id="…">（產品頁 main-product 先有）：
 *   加入之前睇 /cart.js —— 購物車已經有同一款梳化：
 *     款式 / 顏色唔同 → 問「換成而家揀嘅」（預設）定「兩張都要」
 *     款式 + 顏色一樣  → 問「睇購物車」（預設）定「加多一張」
 *   Rybbit 2026-09-24 → 10-01：13 個 session 加咗 2 件或以上（9 個係同一張梳化加兩次 ——
 *   加完再改尺寸、撳多次加入購物車），得 1 個成交；其他喺購物車撳「數量減少」執完就走。
 *   ImDupe.match（純函數，tests/product-form.cjs 測）：購物車行 → 同一款嘅行 + 係咪一模一樣
 *
 * 保養二揀一（main-product buy_buttons 嘅 [data-im-warranty]）：揀咗「升級至 10 年」就一次過加梳化 + 保養計劃
 *   （/cart/add.js 嘅 items[]）；購物車已經有保養計劃就唔再加（同購物車頁升級保養一樣，一張單一份）。
 *   ImDupe.cartPayload / notificationState（純函數，tests/ux-nudges.cjs 測）
 */
(function (root) {
  function propsKey(props) {
    if (!props || typeof props !== 'object') return '';
    return Object.keys(props)
      .filter(function (k) { return props[k] !== null && props[k] !== '' && k.charAt(0) !== '_'; })
      .sort()
      .map(function (k) { return k + '=' + props[k]; })
      .join('&');
  }

  // items: /cart.js 嘅 items；want: { productId, variantId, properties }
  // → { lines: [同一款嘅行], same: 有冇一行 variant + property 一模一樣 }
  function match(items, want) {
    var lines = (items || []).filter(function (it) { return String(it.product_id) === String(want.productId); });
    var key = propsKey(want.properties);
    var same = lines.some(function (it) {
      return String(it.variant_id) === String(want.variantId) && propsKey(it.properties) === key;
    });
    return { lines: lines, same: same };
  }

  // item：serializeForm 出嚟嘅 { id, quantity, properties, … }；planId：要一齊加嘅保養計劃 variant（冇 = null）
  function cartPayload(item, planId, sections, sectionsUrl) {
    if (!planId) return Object.assign({}, item, { sections: sections, sections_url: sectionsUrl });
    var main = { id: item.id, quantity: Number(item.quantity) || 1 };
    if (item.properties) main.properties = item.properties;
    return { items: [main, { id: planId, quantity: 1 }], sections: sections, sections_url: sectionsUrl };
  }

  // 一次加幾件 → /cart/add.js 回 { items: [...], sections }；「已加入購物車」彈窗要第一件（梳化）嘅 variant id
  function notificationState(response) {
    if (response && Array.isArray(response.items) && response.items.length) {
      return Object.assign({}, response, { id: response.items[0].id });
    }
    return response;
  }

  root.ImDupe = { match: match, propsKey: propsKey, cartPayload: cartPayload, notificationState: notificationState };
})(typeof window !== 'undefined' ? window : this);

if (typeof customElements !== 'undefined' && !customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      if (!this.hasAttribute('data-im-dupe-check')) {
        this.addToCart(submitButton, []);
        return;
      }
      this.setLoading(submitButton, true);
      this.askAboutDuplicate().then((decision) => {
        this.setLoading(submitButton, false);
        if (decision.action === 'cancel') return;
        if (decision.action === 'cart') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        this.addToCart(submitButton, decision.action === 'replace' ? decision.removeKeys : []);
      });
    }

    setLoading(submitButton, on) {
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (on) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    addToCart(submitButton, removeKeys) {
      this.setLoading(submitButton, true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const item = JSON.parse(serializeForm(this.form));
      const sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      const plan = this.querySelector('[data-im-warranty] input[type="radio"]:checked');
      const planId = plan && plan.value ? plan.value : null;

      // 「換成而家揀嘅」：先刪走購物車入面同一款嘅舊行，再加新嗰張
      const removeOld = removeKeys.reduce((chain, key) => chain.then(() =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
      ), Promise.resolve());

      // 揀咗升級保養：購物車已經有就唔再加
      const planToAdd = () => {
        if (!planId) return Promise.resolve(null);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => ((cart.items || []).some((it) => String(it.variant_id) === String(planId)) ? null : planId))
          .catch(() => planId);
      };

      removeOld
        .then(planToAdd)
        .then((addPlan) => {
          config.body = JSON.stringify(window.ImDupe.cartPayload(item, addPlan, sections, window.location.pathname));
          return fetch(`${routes.cart_add_url}`, config);
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(window.ImDupe.notificationState(response));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setLoading(submitButton, false);
        });
    }

    // 購物車已經有同一款 → bottom sheet 問客；冇 / 攞唔到購物車 → 照加
    askAboutDuplicate() {
      const data = JSON.parse(serializeForm(this.form));
      const want = { productId: this.dataset.productId, variantId: data.id, properties: data.properties };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const found = window.ImDupe.match(cart.items, want);
          if (!found.lines.length) return { action: 'add' };
          return this.openDupeSheet(found, want);
        })
        .catch(() => ({ action: 'add' }));
    }

    describeWanted(want) {
      const json = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"], [data-sofa-data]');
      let title = '';
      try {
        const parsed = JSON.parse(json.textContent);
        const variants = Array.isArray(parsed) ? parsed : parsed.variants || [];
        const v = variants.find((x) => String(x.id) === String(want.variantId));
        if (v) title = v.title || (v.options || []).join(' / ');
      } catch (e) {}
      const color = want.properties && want.properties['顏色'];
      return (title || '而家揀嘅款式') + (color ? '，' + color : '');
    }

    describeLine(item) {
      const color = item.properties && item.properties['顏色'];
      return (item.variant_title || '') + (color ? '，' + color : '') + (item.quantity > 1 ? ' × ' + item.quantity : '');
    }

    openDupeSheet(found, want) {
      ProductForm.injectDupeStyle();
      return new Promise((resolve) => {
        const name = String(found.lines[0].product_title || '').split('|')[0].trim();
        const box = document.createElement('div');
        box.className = 'im-dupe';
        box.innerHTML =
          '<div class="im-dupe__scrim" data-act="cancel"></div>' +
          '<div class="im-dupe__sheet" role="dialog" aria-modal="true" aria-labelledby="ImDupeTitle">' +
          '<p class="im-dupe__title" id="ImDupeTitle"></p>' +
          '<p class="im-dupe__row"><span>購物車已有</span><b data-have></b></p>' +
          '<p class="im-dupe__row"><span>而家揀咗</span><b data-want></b></p>' +
          '<button type="button" class="im-dupe__btn im-dupe__btn--primary" data-first></button>' +
          '<button type="button" class="im-dupe__btn" data-second></button>' +
          '<button type="button" class="im-dupe__link" data-act="cancel" data-rybbit-event="pdp_dupe_cancel">取消</button>' +
          '</div>';
        box.querySelector('.im-dupe__title').textContent = '購物車已經有「' + name + '」';
        box.querySelector('[data-have]').textContent = found.lines.map((it) => this.describeLine(it)).join('；');
        box.querySelector('[data-want]').textContent = this.describeWanted(want);
        const first = box.querySelector('[data-first]');
        const second = box.querySelector('[data-second]');
        if (found.same) {
          first.textContent = '已經加咗，睇購物車';
          first.dataset.act = 'cart';
          first.dataset.rybbitEvent = 'pdp_dupe_cart';
          second.textContent = '我要多一張';
          second.dataset.act = 'add';
          second.dataset.rybbitEvent = 'pdp_dupe_add';
        } else {
          first.textContent = '換成而家揀嘅';
          first.dataset.act = 'replace';
          first.dataset.rybbitEvent = 'pdp_dupe_replace';
          second.textContent = '兩張都要';
          second.dataset.act = 'add';
          second.dataset.rybbitEvent = 'pdp_dupe_add';
        }
        const done = (action) => {
          document.removeEventListener('keydown', onKey);
          box.remove();
          resolve({ action: action, removeKeys: found.lines.map((it) => it.key) });
        };
        const onKey = (e) => { if (e.key === 'Escape') done('cancel'); };
        box.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-act]');
          if (btn) done(btn.dataset.act);
        });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(box);
        try {
          if (window.rybbit && typeof window.rybbit.event === 'function') window.rybbit.event('pdp_dupe_prompt', { same: found.same ? 1 : 0 });
        } catch (e) {}
        first.focus({ preventScroll: true });
      });
    }

    static injectDupeStyle() {
      if (document.getElementById('ImDupeStyle')) return;
      const style = document.createElement('style');
      style.id = 'ImDupeStyle';
      style.textContent =
        '.im-dupe__scrim{position:fixed;inset:0;z-index:1000;background:rgba(18,18,18,.45)}' +
        '.im-dupe__sheet{position:fixed;left:0;right:0;bottom:0;z-index:1001;max-width:52rem;margin:0 auto;padding:2rem 2rem calc(2rem + env(safe-area-inset-bottom,0px));' +
        'background:#fff;color:#121212;border-radius:16px 16px 0 0;box-shadow:0 -8px 24px rgba(0,0,0,.12);font-size:1.5rem;line-height:1.6}' +
        '.im-dupe__title{margin:0 0 1rem;font-size:1.8rem;font-weight:700;line-height:1.4}' +
        '.im-dupe__row{display:flex;gap:1rem;margin:0 0 .6rem}.im-dupe__row span{flex:none;color:#555}.im-dupe__row b{font-weight:600}' +
        '.im-dupe__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:4.8rem;margin:1rem 0 0;padding:0 1.6rem;' +
        'border:1.5px solid #121212;border-radius:999px;background:#fff;color:#121212;font:inherit;font-size:1.6rem;font-weight:700;cursor:pointer}' +
        '.im-dupe__btn--primary{background:#121212;color:#fff}' +
        '.im-dupe__link{display:block;width:100%;margin:.6rem 0 0;padding:1rem 0;border:0;background:none;color:#555;font:inherit;text-decoration:underline;cursor:pointer}';
      document.head.appendChild(style);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
